//如果要预渲染那么不能进行懒加载
import Home from '@/components/home/Home.vue';
import Product from '@/components/product/Product.vue';
import Productindex from '@/components/product/Index.vue';
import Productcontent from '@/components/product/Content.vue';
import Collect from '@/components/collect/Collect.vue';
import Ability from '@/components/order/Order.vue';
import Team from '@/components/invoice/Invoice.vue';
import Advantage from '@/components/advantage/Advantage.vue';
import About from '@/components/about/About.vue';
import Login from '@/components/login/Login.vue';
import Retrieve from '@/components/retrieve/Retrieve.vue';
// import Goods from '@/components/goods/Goods.vue';
import Article from '@/components/article/Article.vue';
import Articleindex from '@/components/article/Index.vue';
import Articlecontent from '@/components/article/Content.vue';
import Group from '@/components/group/Group.vue';
import Groupindex from '@/components/group/Index.vue';
import Groupcontent from '@/components/group/Content.vue';
import Paypalurl from '@/components/common/paypal.vue';

export const routes = [
    {
      path: '/',
      name:'home',
      meta: {
        // 需要登录控制
        NProgress: true,
        // 需要登录控制
        requireAuth: true
      },
      component: Home
    },
  {
    path: '/collect',
    name:'collect',
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: true
    },
    component: Collect
  },
  {
    path: '/about',
    name:'about',
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: false
    },
    component: About
  },
  {
    path: '/login',
    name:'login',
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: false
    },
    component: Login
  },
  {
    path: '/retrieve',
    name:'retrieve',
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: false
    },
    component: Retrieve
  },
    {
      path: '/order',
      name:'ability',
      meta: {
        // 需要登录控制
        NProgress: true,
        // 需要登录控制
        requireAuth: true
      },
      component: Ability
    },
    {
      path: '/invoice',
      name:'team',
      meta: {
        // 需要登录控制
        NProgress: true,
        // 需要登录控制
        requireAuth: true
      },
      component: Team
    },
    // {
    //   path: '/contact',
    //   name:'contact',
    //   component: Contact
    // },
    {
      path: '/advantage',
      name:'advantage',
      meta: {
        // 需要登录控制
        NProgress: true,
        // 需要登录控制
        requireAuth: true
      },
      component: Advantage
    },
    {
      path: '/article',
      children: [
        // 资产仓库
        {
          path: '/',
          name: 'article',
          components: {
            default: Articleindex
          },
          meta: {
            // 需要登录控制
            NProgress: true,
            // 需要登录控制
            requireAuth:true
          }
        },
        {
          path:'/article/:id',
          name: 'articlecontent',
          props:(route)=>{
            return {
              id:route.params.id
            }
          },
          component:Articlecontent,
          meta: {
            // 需要登录控制
            NProgress: true,
            // 需要登录控制
            requireAuth:true
          }
        }
      ],
      meta: {
        // 需要登录控制
        NProgress: true,
        // 需要登录控制
        requireAuth:true
      },
      component: Article
    },

  {
    path: '/product',
    children: [
      // 资产仓库
      {
        path: '/',
        name: 'product',
        components: {
          default: Productindex
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth:true
        }
      },
      // 资产仓库
      {
        path: '/product/:id',
        name: 'productcontent',
        props:(route)=>{
          return {
            id:route.params.id
          }
        },
        component:Productcontent,
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth:true
        }
      }
    ],
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: true
    },
    component: Product
  },

  {
    path: '/group',
    children: [
      // 资产仓库
      {
        path: '/',
        name: 'group',
        components: {
          default: Groupindex
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth:true
        }
      },
      // 资产仓库
      {
        path: '/group/:id',
        name: 'groupcontent',
        props:(route)=>{
          return {
            id:route.params.id
          }
        },
        component:Groupcontent,
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth:true
        }
      }
    ],
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: true
    },
    component: Group
  },



  {
    path: '/paypal/:no',
    name: 'paypalid',
    props:(route)=>{
      return {
        no:route.params.no
      }
    },
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth:true
    },
    component: Paypalurl
  },
  // {
  //   path: '/goods',
  //   name:'goods',
  //   meta: {
  //     // 需要登录控制
  //     NProgress: true,
  //     // 需要登录控制
  //     requireAuth: true
  //   },
  //   component: Goods
  // },
    {
    	path:'*',
    	redirect:'/'
    }
];



// WEBPACK FOOTER //
// ./src/router/routes.js